import Navbar from "../../components/Navbar";
import WhatsInside from "../../components/WhatsInside";
import Introduction from "../../components/Introduction";
import GetStarted from "../../components/GetStarted";
import Footer from "../../components/Footer";
import {useState} from "react";

const Product = () => {
    const [productType, setProductType] = useState(0)

    return (
        <>
            <Navbar setProductType={setProductType}/>
            <WhatsInside productType={productType}/>
            <Introduction/>
            <GetStarted/>
            <Footer/>
        </>
    )
}

export default Product;